import React, { forwardRef } from 'react'
import { SvgIcon, useTheme } from '@mui/material'

/**
 * The CircleErrorIcon's component.
 */
const CircleErrorIcon = forwardRef((props, ref) => {
  const { palette } = useTheme()

  return (
    <SvgIcon
      {...props}
      height="64px"
      ref={ref}
      version="1.1"
      viewBox="0 0 65 64"
      width="65px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(0.500000, 0.000000)">
          <circle cx="32" cy="32" fill={palette.red[90]} r="32" />
          <g fill={palette.brand.error} transform="translate(13.000000, 13.000000)">
            <polygon points="30.0338542 10.1432292 21.2018229 18.9752604 30.0338542 27.8072917 27.8072917 30.0338542 18.9752604 21.2018229 10.1432292 30.0338542 7.91666667 27.8072917 16.7486979 18.9752604 7.91666667 10.1432292 10.1432292 7.91666667 18.9752604 16.7486979 27.8072917 7.91666667" />
          </g>
        </g>
      </g>
    </SvgIcon>
  )
})

export default CircleErrorIcon
